import '.a{display:flex;}.ssr-plugin'
import '.ab{align-items:stretch;}.ssr-plugin'
import '.h{justify-content:center;}.ssr-plugin'
import '.b{flex-direction:column;}.ssr-plugin'
import '.cn{background:var(--shades-white);}.ssr-plugin'
import '.cg{flex-grow:1;}.ssr-plugin'
import '.c{align-items:center;}.ssr-plugin'
import '.at{max-width:77.5rem;}.ssr-plugin'
import '.co{justify-content:stretch;}.ssr-plugin'
import '.cp{position:sticky;}.ssr-plugin'
import '.ch{top:0;}.ssr-plugin'
import '.cq{z-index:10;}.ssr-plugin'
import '.cr{padding-block:1rem;}.ssr-plugin'
import '.cs{height:3rem;}.ssr-plugin'
import '.a9{justify-content:space-between;}.ssr-plugin'
import '.ct{flex-wrap:wrap;}.ssr-plugin'
import '.cu{min-height:calc(100vh - 5rem);}.ssr-plugin'
import '.ar{margin-top:2rem;}.ssr-plugin'
import '.g8{padding-bottom:1.5rem;}.ssr-plugin'
import { ReactNode, useEffect } from 'react'
import { styled } from 'inlines'
import { Property } from 'csstype'
import useMediaQuery from '@app/util/useMediaQuery'
import { Title } from '@app/components/core/typography/Title'
import { CloseButton } from '@app/components/core/button/CloseButton'
import { pages } from '@app/util/links'
import { useLocation } from 'wouter'
import { ClientOnly, useAuthState } from '@based/sdk/react'

export const InitiativeCreatePageLayout = ({
  title,
  gap = '1rem',
  children,
  onClose,
}: {
  title: string
  gap?: Property.Gap<(string & {}) | 0>
  children: ReactNode
  onClose: VoidFunction
}) => {
  const isMobile = useMediaQuery()

  const authState = useAuthState()
  const [_location, navigate] = useLocation()
  const isAuthed = authState && authState.userId

  useEffect(() => {
    if (!isAuthed) {
      navigate(pages.home)
    }
  }, [isAuthed, navigate])

  return (
    <ClientOnly>
      <div className="a ab h b cn"
      >
        <div className="cg a c h b"
        >
          <div className="at a b co cp ch cq"
            style={{
              width: isMobile ? '100%' : '85%',
              paddingInline: isMobile ? '5rem' : 0,}}
          >
            <nav className="cr cs a a9 c ct"
            >
              <Title.H5>{title}</Title.H5>
              <CloseButton onClick={onClose} />
            </nav>
          </div>
          <div className="cu a b ab ar g8 at"
            style={{
              gap: gap,
              width: isMobile ? '100%' : '85%', // 8rem is padding + navbar height
              paddingInline: isMobile ? '5rem' : 0,}}
          >
            {children}
          </div>
        </div>
      </div>
    </ClientOnly>
  )
}
